export { NewActivityButton, getLabelText } from './NewActivityButton';
